import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-multi-line-text',
  templateUrl: './multi-line-text.component.html',
  styleUrls: ['./multi-line-text.component.scss']
})
export class MultiLineTextComponent extends FieldType implements OnInit, OnDestroy {

  @ViewChild('textareaEl', {static: true}) textareaEl: ElementRef;
  subscription = new Subscription();

  constructor() {
    super();
   }

  onChange(e: any) {
    this.formControl.setValue(this.textareaEl.nativeElement.value);
    this.formControl.markAsTouched();
    this.formControl.markAsDirty();
  }

  ngOnInit() {
    this.subscription.add(this.formControl.valueChanges.subscribe(value => {
      this.textareaEl.nativeElement.value = value || '';
    }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
